export default __webpack_public_path__ + "4ba931842673498a92ddaf45d3effcf8.png";